import { z } from 'zod'

import { DateStringSchema, type ZodInfer } from '@mntn-dev/utility-types'

import { ChargeStatusSchema } from '../billing/charge-status.ts'
import { UbsInvoiceIdSchema } from './ubs-invoice-id.ts'
import { UbsPaymentIdSchema } from './ubs-payment-id.ts'
import { UbsRefundIdSchema } from './ubs-refund-id.ts'

export const UbsRefundSchema = z.object({
  refundId: UbsRefundIdSchema,
  paymentId: UbsPaymentIdSchema,
  invoiceId: UbsInvoiceIdSchema,
  amount: z.number(),
  status: ChargeStatusSchema,
  requestedAt: DateStringSchema,
  processedAt: DateStringSchema.optional(),
  createdAt: DateStringSchema,
  metadata: z.record(z.string(), z.any()),
})

export type UbsRefund = ZodInfer<typeof UbsRefundSchema>
